export default __webpack_public_path__ + "static/media/large.254879ee.jpg";